import React, { FC, memo, useState } from "../../../lib/teact/teact";
import ConfirmDialog from "../../ui/ConfirmDialog";
import InputText from "../../ui/InputText";
import LotSelect from "../ui/lotSelect";
import MyDateInput from "../ui/myDateInput";
import { getCurDate } from "../utils/DateTimeUtils";

type OwnProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (param: any) => void;
}

const DialogGetTestMessage: FC<OwnProps> = ({
    isOpen,
    onClose,
    onConfirm }) => {
    const fromDate = new Date(getCurDate());
    fromDate.setMonth(fromDate.getMonth() - 3); // trừ 3 tháng  
    const [state, setState] = useState({
        mien:"NAM" as "NAM" | "BAC" | "TRUNG",
        thu: 1,
        tinhId: "TP",
        fromDate: fromDate.toISOString().split('T')[0],
        toDate: getCurDate(),
        lenFrom: 1000,
        lenTo: 15000,
        limit: 100,
    })

    return (
        <ConfirmDialog isOpen={isOpen}
            onClose={onClose}
            confirmHandler={() => {
                onConfirm(state);
                onClose();
            }}
            title="Get Test Message"
        >
            <div className=" form-content">
                <LotSelect
                    label="miền"
                    value={state.mien}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, mien: e.target.value as "NAM" | "BAC" | "TRUNG" }))
                    }}
                >
                    <option value="NAM" selected={state.mien == "NAM"}>Miền Nam</option>
                    <option value="BAC" selected={state.mien == "BAC"}>Miền Bắc</option>
                    <option value="TRUNG" selected={state.mien == "TRUNG"}>Miền Trung</option>
                </LotSelect>
                <InputText label="thứ: 1-7" value={state.thu} onChange={(e) => {
                    setState(prev => ({ ...prev, thu: Number(e.target.value) }))
                }}></InputText>
                <InputText label="tỉnh: TP,DTH,CM..." value={state.tinhId}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, tinhId: e.target.value }))
                    }}></InputText>
                <MyDateInput labelPosition="top" label="từ ngày"
                    onChange={(e) => {
                        setState(prev => ({ ...prev, fromDate: e.target.value }))
                    }} value={state.fromDate}></MyDateInput>
                <MyDateInput labelPosition="top" label="đến ngày"
                    onChange={(e) => {
                        setState(prev => ({ ...prev, toDate: e.target.value }))
                    }} value={state.toDate}></MyDateInput>
                <InputText label="độ dài từ" value={state.lenFrom}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, lenFrom: Number(e.target.value) }))
                    }
                    }
                ></InputText>
                <InputText label="độ dài đến" value={state.lenTo}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, lenTo: Number(e.target.value) }))
                    }
                    }
                ></InputText>
                <InputText label="giới hạn (số lượng tin nhắn)" value={state.limit}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, limit: Number(e.target.value) }))
                    }
                    }
                ></InputText>
            </div>
        </ConfirmDialog>
    )
}

export default memo(DialogGetTestMessage);